import {BASE_URL} from "@/constants/config";
import {request} from "@/utils/request";

export const ANALYSIS_ENDPOINTS = {
  compare_annexei_and_annexeii: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/annexei-annexeii/`,

  compare_annexei_and_annexeii_download: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/annexei-annexeii/download/`,

  compare_riskfile_and_annexeii: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/riskfile-annexeii/`,

  compare_riskfile_and_annexeii_download: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/riskfile-annexeii/download/`,

  compare_annexei_and_annexeiii: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/annexei-annexeiii/`,

  compare_annexei_and_annexeiii_download: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/annexei-annexeiii/download/`,

  evolution_of_annex: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/evolution-of-annex/`,

  evolution_of_annex_download: (campaign_id, member_id) =>
    `${BASE_URL}api/analysis/${campaign_id}/${member_id}/evolution-of-annex/download/`,
};

class Analysis {
  async getCompareAnnexeIAndAnnexeII(campaign_id, member_id) {
    const { data } = await request({
      url: ANALYSIS_ENDPOINTS.compare_annexei_and_annexeii(campaign_id, member_id)
    });
    return data;
  }

  async getCompareRiskFileAndAnnexeII(campaign_id, member_id) {
    const { data } = await request({
      url: ANALYSIS_ENDPOINTS.compare_riskfile_and_annexeii(campaign_id, member_id)
    });
    return data;
  }

  async getCompareAnnexeIAndAnnexeIII(campaign_id, member_id) {
    const { data } = await request({
      url: ANALYSIS_ENDPOINTS.compare_annexei_and_annexeiii(campaign_id, member_id)
    });
    return data;
  }

  async getEvolutionOfAnnex(campaign_id, member_id) {
    const { data } = await request({
      url: ANALYSIS_ENDPOINTS.evolution_of_annex(campaign_id, member_id)
    });
    return data;
  }
}

export const AnalysisService = new Analysis();
